/**
 * AI 分析空状态：引导用户选择分析方式（approach）。
 */
import React, { memo } from 'react';
import { useIntl } from 'umi';
import { Button } from 'tea-component';
import StartsSvg from '@/pages/datalab/assets/svg/starts.svg';
import type { IAiStatusEmptyProps } from '../../types';
import './shared.scss';

const AiStatusEmpty: React.FC<IAiStatusEmptyProps> = (props) => {
  const { onOpenAnalysisApproach } = props;
  const { formatMessage } = useIntl();

  return (
    <div className="dbl-ai-status dbl-ai-status--empty">
      <img className="dbl-ai-status__empty-icon" src={StartsSvg} alt="" aria-hidden />

      <p className="dbl-ai-status__desc">
        {formatMessage({ id: 'dbl_ai_analysis_card_desc' })}
        <Button
          type="link"
          className="dbl-ai-status__action"
          onClick={onOpenAnalysisApproach}
        >
          {formatMessage({ id: 'dbl_ai_analysis_analysis_approach' })}
        </Button>
      </p>
    </div>
  );
};

export default memo(AiStatusEmpty);
